import React, { useContext } from 'react'
import error from 'images/404-error (1).png'
import { themeContext } from 'contexts/theme_context/ThemeContext'
import { useNavigate } from 'react-router'

export default function NotFound() {
    let {webtheme}=useContext(themeContext)
    let navto= useNavigate()
    return (
        <div className='vh-100 col-12 d-flex align-items-center justify-content-center '>

            <div className={`col-lg-3 col-sm-5 col-xs-6  `}>
                <div className='col-10 text-center '>
                    <h1 className={`fs-3  overflow-hidden ${webtheme}-text`}>Page Not Found</h1>
                </div>
                <div className='col-10'>
                    <img src={error} alt="" className='col-12'/>
                </div>
                <div className='col-10 text-center cursor' onClick={()=>{navto('/')}}>
                    <span className='text-primary'>Back to home </span>
                </div>
            </div>
        </div>
    )
}
